





















































































































































































































































import Vue from 'vue';

import TopNav from '@/web/components/navigation/TopNav.vue';
import IntegrationCard from '@/web/components/settings/IntegrationCard.vue';
import { mapGetters } from 'vuex';
import TeacherPermissionsMixin from '@/web/mixins/TeacherPermissionsMixin';

export default Vue.extend({
  components: {
    TopNav,
    IntegrationCard,
  },
  mixins: [TeacherPermissionsMixin],
  data() {
    return {
      isLoading: true,
      integrations: {
        calendly: {
          routeName: 'settings-integrations-calendly-old',
          img: '/assets/images/integrations/calendly@3x.png',
          text: 'SETTINGS.TEXT.CONNECT_YOUR_CALENDLY_ACCOUNT_DEPRECATED',
          status: 'connect',
        },
        googlecalendar: {
          routeName: 'settings-integrations-googlecalendar',
          img: '/assets/images/integrations/google-calendar.png',
          text: 'SETTINGS.TEXT.CONNECT_YOUR_GOOGLE_CALENDAR',
          status: 'connect',
        },
        calendlyV2: {
          routeName: 'settings-integrations-calendly',
          img: '/assets/images/integrations/calendly@3x.png',
          text: 'SETTINGS.TEXT.CONNECT_YOUR_CALENDLY_ACCOUNT',
          status: 'connect',
        },
        acuity: {
          routeName: 'settings-integrations-acuity',
          img: '/assets/images/integrations/acuity@3x.jpg',
          text: 'SETTINGS.TEXT.CONNECT_YOUR_ACUITY_SCHEDULING_ACCOUNT',
          status: 'connect',
        },
        flodesk: {
          routeName: 'settings-integrations-flodesk',
          img: '/assets/images/integrations/flodesk.png',
          text: 'SETTINGS.TEXT.AUTOMATICALLY_ADD_YOUR_STUDENTS_TO_FLODESK',
          status: 'connect',
        },
        convertkit: {
          routeName: 'settings-integrations-convertkit',
          img: '/assets/images/integrations/convertkit@3x.png',
          text: 'SETTINGS.TEXT.AUTOMATICALLY_ADD_YOUR_STUDENTS_TO_CONVERTKIT',
          status: 'connect',
        },
        mailchimp: {
          routeName: 'settings-integrations-mailchimp',
          img: '/assets/images/integrations/mail-chimp@3x.png',
          text: 'SETTINGS.TEXT.AUTOMATICALLY_ADD_YOUR_STUDENTS_TO_MAILCHIMP',
          status: 'connect',
        },
        googlemail: {
          routeName: 'settings-integrations-googlemail',
          img: '/assets/images/integrations/gmail-logo.png',
          text: 'SETTINGS.TEXT.CONNECT_YOUR_GOOGLE_MAIL',
          status: 'connect',
        },
        smtp: {
          routeName: 'settings-integrations-smtp',
          img: '/assets/images/integrations/smtp.svg',
          text: 'SETTINGS.TEXT.CONNECT_YOUR_SMTP_ACCOUNT',
          status: 'connect',
        },
        twilio: {
          routeName: 'settings-integrations-twilio',
          img: '/assets/images/integrations/twilio.svg',
          text: 'SETTINGS.TEXT.CONNECT_YOUR_TWILIO_ACCOUNT',
          status: 'connect',
        },
        paypal: {
          routeName: 'settings-integrations-paypal',
          img: '/assets/images/integrations/pay-pal@3x.png',
          text: 'SETTINGS.TEXT.COLLECT_PAYMENTS_WITH_PAYPAL',
          iconClass: 'icon-small',
          status: 'connect',
        },
        stripe: {
          routeName: 'settings-integrations-stripe',
          img: '/assets/images/integrations/stripe@3x.png',
          text: 'SETTINGS.TEXT.COLLECT_CREDIT_CARD_PAYMENTS_FROM_YOUR',
          iconClass: 'icon-smaller',
          status: 'connect',
        },
        tipJar: {
          routeName: 'settings-integrations-tip-jar',
          img: '/assets/images/integrations/tip_jar_logo.svg',
          text: 'SETTINGS.TEXT.TIP_JAR_DESC',
          status: 'connect',
        },
        facebookPixel: {
          routeName: 'settings-integrations-facebook-pixel',
          img: '/assets/images/integrations/facebook-pixel@3x.png',
          text: 'SETTINGS.TEXT.ADD_YOUR_FACEBOOK_PIXEL_CODE',
          status: 'connect',
        },
        googleAnalyticsCode: {
          routeName: 'settings-integrations-google-analytics',
          img: '/assets/images/integrations/google-analytics.png',
          text: 'SETTINGS.TEXT.ADD_YOUR_GOOGLE_ANALYTICS_CODE',
          iconClass: 'icon-small',
          status: 'connect',
        },
        deadlineFunnel: {
          routeName: 'settings-integrations-deadline-funnel',
          img: '/assets/images/integrations/deadline-funnel@3x.png',
          text: 'SETTINGS.TEXT.ADD_A_SENSE_OF_URGENCY_TO_CHECKOUT',
          status: 'connect',
        },
        zapier: {
          routeName: 'settings-integrations-zapier',
          img: '/assets/images/integrations/zapier@3x.png',
          text: 'SETTINGS.TEXT.CONNECT_TO_ZAPIER',
          status: 'connect',
        },
        rewardful: {
          routeName: 'settings-integrations-rewardful',
          img: '/assets/images/integrations/rewardful-logo.svg',
          text: 'SETTINGS.TEXT.CONNECT_REWARDFUL',
          status: 'connect',
        },
        instagram: {
          routeName: 'settings-integrations-instagram',
          img: '/assets/images/integrations/instagram@3x.png',
          text: 'SETTINGS.TEXT.CONNECT_YOUR_INSTAGRAM_ACCOUNT',
          status: 'connect',
        },
        zoom: {
          routeName: 'settings-integrations-zoom',
          img: '/assets/images/integrations/zoom@3x.png',
          text: 'SETTINGS.TEXT.GET_UNLIMITED_LIVE_STREAMING',
          iconClass: 'icon-small',
          status: 'connect',
        },
        googleMeet: {
          routeName: 'settings-integrations-google-meet',
          img: '/assets/images/integrations/google-meet.svg',
          text: 'SETTINGS.TEXT.CONNECT_YOUR_GOOGLE_MEET',
          status: 'connect',
        },
      },
    };
  },
  computed: {
    ...mapGetters('user', ['teacher', 'instagramConnected']),
  },
  methods: {},
  async mounted() {
    const { can_access_deadline_funnel } = this.teacher;

    // Use the consolidated API endpoint instead of multiple individual calls
    const integrationsStatus = await this.$store.dispatch(
      'setting/getIntegrationsStatus'
    );

    // Update integration statuses based on consolidated response
    this.integrations.calendly.status = integrationsStatus.calendly
      ? 'connected'
      : 'connect';
    this.integrations.calendlyV2.status = integrationsStatus.calendly_v2
      ? 'connected'
      : 'connect';

    const email = integrationsStatus.email_provider;
    this.integrations.flodesk.status = 'connect';
    this.integrations.mailchimp.status = 'connect';
    this.integrations.convertkit.status = 'connect';
    if (email === 'flodesk' && integrationsStatus.flodesk_connected) {
      this.integrations.flodesk.status = 'connected';
    } else if (email === 'convertkit') {
      this.integrations.convertkit.status = 'connected';
    } else if (email === 'mailchimp') {
      this.integrations.mailchimp.status = 'connected';
    }

    const gateway = integrationsStatus.payment_gateway;
    if (gateway === 'stripe') {
      this.integrations.stripe.status = 'connected';
      this.integrations.paypal.status = 'connect';
    } else if (gateway === 'paypal') {
      this.integrations.paypal.status = 'connected';
      this.integrations.stripe.status = 'connect';
    } else {
      this.integrations.stripe.status = 'connect';
      this.integrations.paypal.status = 'connect';
    }

    this.integrations.facebookPixel.status = integrationsStatus.fb_pixel_id
      ? 'connected'
      : 'connect';
    this.integrations.googleAnalyticsCode.status = integrationsStatus.google_analytics_code
      ? 'connected'
      : 'connect';
    this.integrations.googlecalendar.status = integrationsStatus.google_calendar_connections
      ? 'connected'
      : 'connect';
    this.integrations.zoom.status = integrationsStatus.zoom_connections
      ? 'connected'
      : 'connect';
    this.integrations.acuity.status = integrationsStatus.is_acuity_connected
      ? 'connected'
      : 'connect';
    this.integrations.twilio.status = integrationsStatus.is_twilio_connected
      ? 'connected'
      : 'connect';
    this.integrations.rewardful.status = integrationsStatus.rewardful_api_key
      ? 'connected'
      : 'connect';
    this.integrations.googlemail.status = integrationsStatus.google_mail_connections
      ? 'connected'
      : 'connect';
    this.integrations.googleMeet.status = integrationsStatus.google_meet_connections
      ? 'connected'
      : 'connect';
    this.integrations.smtp.status = integrationsStatus.is_smtp_connected
      ? 'connected'
      : 'connect';
    this.integrations.tipJar.status = integrationsStatus.tip_jar_enabled
      ? 'connected'
      : 'connect';

    if (can_access_deadline_funnel) {
      this.integrations.deadlineFunnel.status = integrationsStatus.deadline_funnel_key
        ? 'connected'
        : 'connect';
    } else {
      this.integrations.deadlineFunnel.status = 'disabled';
      this.integrations.deadlineFunnel.routeName = 'settings-adjust-plan';
    }

    this.integrations.instagram.status = integrationsStatus.instagram_connected
      ? 'connected'
      : 'connect';

    this.isLoading = false;
  },
});
